package org.zq.astrock_ai.quant

import kotlinx.serialization.Serializable

@Serializable
data class QuantBar(
    val date: String,
    val open: Double,
    val high: Double,
    val low: Double,
    val close: Double,
    val volume: Double = 0.0,
)

enum class QuantSide {
    BUY,
    SELL,
    HOLD,
}

@Serializable
data class StrategyInfo(
    val id: String,
    val name: String,
    val description: String,
    val defaultParams: Map<String, String> = emptyMap(),
)

@Serializable
data class QuantSignal(
    val strategyId: String,
    val strategyName: String,
    val side: String,
    val reason: String,
    val asOf: String,
    val price: Double,
    val params: Map<String, String> = emptyMap(),
)

@Serializable
data class BacktestTrade(
    val entryDate: String,
    val exitDate: String,
    val entryPrice: Double,
    val exitPrice: Double,
    val returnPct: Double,
)

@Serializable
data class BacktestResult(
    val strategyId: String,
    val strategyName: String,
    val lookbackDays: Int,
    val trades: Int,
    val winRate: Double,
    val totalReturnPct: Double,
    val maxDrawdownPct: Double,
    val tradeDetails: List<BacktestTrade> = emptyList(),
    /** 归一化权益曲线（起点≈1.0），已降采样便于传输与绘图 */
    val equityCurve: List<Double> = emptyList(),
    val params: Map<String, String> = emptyMap(),
    val note: String = "",
)

@Serializable
data class ConsensusVote(
    val strategyId: String,
    val strategyName: String,
    val side: String,
    val reason: String,
)

@Serializable
data class QuantConsensus(
    val side: String,
    val buyCount: Int,
    val sellCount: Int,
    val holdCount: Int,
    val score: Int,
    val summary: String,
    val votes: List<ConsensusVote> = emptyList(),
)

/** 持仓上下文：仅用用户明确提供的成本/数量，不得假设。 */
data class PositionContext(
    val hasPosition: Boolean,
    val costPrice: Double? = null,
    val quantity: Int? = null,
    val currentPrice: Double? = null,
)

@Serializable
data class QuantPlan(
    val strategyId: String,
    val strategyName: String,
    val action: String,
    val summary: String,
    val entryHint: String,
    val exitHint: String,
    val invalidation: String,
    val signal: QuantSignal,
    val backtest: BacktestResult,
    val consensus: QuantConsensus? = null,
    val positionNote: String? = null,
)

@Serializable
data class QuantBundle(
    val strategies: List<StrategyInfo> = emptyList(),
    val signal: QuantSignal? = null,
    val backtest: BacktestResult? = null,
    val plan: QuantPlan? = null,
    val consensus: QuantConsensus? = null,
)
